import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { hoslogPlanRequestQueries } from '@/services/hoslog-plans/hoslog-plans-request.queries';
import { StatusType } from '@/services/hoslog-plans/hoslog-plans.types';
import { useSearch } from '@tanstack/react-router';

const useParams = () => {
  const search = useSearch({ from: '/(app)/configuration-management/hoslog-plans/' });
  const { page, fetch, sort, statusFilter, createdDate } = search;
  const parsedCreatedDate = parseDateRangeSearch(createdDate, { start: 0, end: 0 });
  return {
    row: page,
    fetch: fetch ?? 10,
    search: search.q ?? '',
    sort,
    statusFilter,
    fromDate: parsedCreatedDate?.start,
    toDate: parsedCreatedDate?.end,
  };
};
export const useHoslogPlansRequestList = (type: StatusType, enabled: boolean) => {
  const { sort, ...params } = useParams();
  const { data, isLoading } = useQuery({
    ...hoslogPlanRequestQueries.list(type, params),
    enabled,
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
  });

  return { hoslogPlansRequestList: data?.data || [], isLoading, requestMeta: data?.meta?.pagination ?? defaultMeta };
};
